<template>
  <el-backtop :right="0" :bottom="NaN" class="back-to-top__root" :style="rootStyle" target=".lowcode-root.scroll">
    <div class="back-to-top__content">
      <IconMyIconToTop class="icon-to-top"></IconMyIconToTop>
      <span class="label">置顶</span>
    </div>
  </el-backtop>
</template>
<script lang="ts" setup>
import { useZIndex } from 'element-plus';
import { computed } from 'vue';

const nextZIndex = useZIndex().nextZIndex();
const rootStyle = computed(() => {
  return { zIndex: nextZIndex, position: 'absolute', top: '-48px' };
});
</script>
<style lang="scss" scoped>
.back-to-top {
  &__root {
    width: auto;
    height: auto;
    box-shadow: none;
  }
  &__content {
    box-sizing: border-box;
    flex: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: var(--lowcode-background-01);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--lowcode-custom-border-14);
    border-radius: 24px;
    overflow: hidden;

    &:hover {
      background: #2c71fa;
      color: #fff;
      .label {
        display: block;
      }
      .icon-to-top {
        display: none;
        // :deep(path) {
        //   fill: #fff;
        // }
      }
    }

    &:active {
      background: #1c53d4;
    }

    .label {
      display: none;
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      color: #ffffff;
    }
  }
}
</style>
